module.exports = __webpack_public_path__ + "img/12.9e96e54a.svg";